module.exports = "/images/vessel-14.jpg";